<template>
  <div class="sidepanel">
    <LogoHeader :handleClick="onCreateNewConversation" />

    <BbLoadingIndicator v-if="isDataLoading" />

    <div v-else-if="!userConversations.length" class="no-content">
      <TextBody i18n-key="conversation.noConversationsFound" />
    </div>

    <div v-else class="conversation-card-container">
      <div v-for="(group, createdAt) in groupedConversations" :key="createdAt">
        <TextBody :body-type="3" :i18n-key="createdAt" tag="div" weight="medium" />
        <ConversationCard
          v-for="conversation in group"
          :key="conversation.conversationId"
          :conversation="conversation"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref, watch } from 'vue';
import { groupBy } from 'lodash';
import { useStore } from 'vuex';

import useConversations from '~/composables/useConversations';
import { SetAllUserConversations } from '~/constants/mutations';
import arcaneLogo from '~/assets/svg/Arcane-logo.svg';
import { getGroupTimestamp, sortByTimestamp } from '~/utils/date-utils';

import ConversationCard from '~/components/conversation/ConversationCard';
import TextBody from '~/components/common/TextBody';
import LogoHeader from '~/components/common/LogoHeader';

export default {
  components: { TextBody, ConversationCard, LogoHeader },

  setup() {
    const store = useStore();

    const { userConversations, initialiseConversation } = useConversations();

    const isDataLoading = ref(true);

    const groupedConversations = computed(() =>
      groupBy(sortByTimestamp(userConversations.value), (conversation) => getGroupTimestamp(conversation.timestamp)),
    );

    const searchValue = ref('');

    const onCreateNewConversation = () => initialiseConversation();

    watch(searchValue, (newValue, oldValue) => {
      console.log(`The new value is: ${newValue}, and the old value was: ${oldValue}`);
    });

    onMounted(async () => {
      // get all user conversations
      await store.dispatch(`conversationStore/${SetAllUserConversations}`);
      isDataLoading.value = false;
    });

    return {
      arcaneLogo,
      userConversations,
      groupedConversations,
      isDataLoading,
      searchValue,
      onCreateNewConversation,
    };
  },
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}

.sidepanel {
  @include media-breakpoint-up('sm') {
    display: flex;
  }

  height: 100%;
  min-width: 260px;
  max-width: 260px;
  display: none;
  flex-direction: column;
  background-color: $bb-neutral-0;
  padding: 0 20px 16px 20px;
  border-right: 1px solid $bb-neutral-4;

  .spinner {
    background-color: inherit;
  }

  .no-content {
    @include bb-regular-text-styles('sm');
    display: flex;
    justify-content: center;
    color: $bb-neutral-3;
    padding: $bb-spacing-2 $bb-spacing-4;
  }

  .conversation-card-container {
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 16px;

    :deep(.body-3) {
      color: $bb-neutral-3;
      letter-spacing: 0.1px;
      font-size: 13px;
      margin-bottom: $bb-spacing-2;
    }

    // width: 100%;
  }
}
</style>
